<div class="location-area">
  <div id="map" style="width: 100%; height: 600px; position: absolute;"></div>
  <div class="container">
    <div class="row">
      <div class="col df-location">
        <div class="container location-info pt-2">
          <div class="row mb-2 pb-2">
            <div class="col-2 location-icon text-center py-2">
              <img src="/assets/images/svg/icon_location.svg" alt="Location" title="Location" />
            </div>
            <div class="col-10">
              <div class="title py-2">{{location.description}}</div>
              <div>{{location.address_line1}}</div>
              <div *ngIf="location.address_line2 != ''">{{location.address_line2}}</div>
              <div>{{location.city}}, {{location.state}} {{location.zip_code}}</div>
              <div class="pt-2" *ngIf="location.phone != ''">Phone: <a href="tel:{{location.phone}}">{{location.phone | phoneFormat}}</a></div>
              <div class="pt-2" *ngIf="location.email != ''">Email: <a href="mail:{{location.email}}">{{location.email}}</a></div>
            </div>
          </div>
          <div class="row border-top mb-2 pt-2">
            <div class="col-2 location-icon text-center py-2">
              <img src="/assets/images/svg/icon_hours.svg" alt="Hours" title="Hours" />
            </div>
            <div class="col-10">
              <div class="title py-2">Hours of Operation will begin when we open</div>
              <div class="row g-0" *ngFor="let group of groupLocationHours()">
                <div class="col-5">
                  {{ group.range }}:
                </div>
                <div class="col-7">
                  <ng-container *ngFor="let t of group.times; let last = last">
                    {{ t }}<span *ngIf="!last"> | </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="row border-top">
            <div class="col-2"></div>
            <div class="col-10 py-3">
              <a class="btn btn-primary rounded-pill px-4 py-2 rounded-pill-btn" style="font-size: 14px;" target="_blank" [href]="directionUrl">GET DIRECTIONS</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>